// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"e1c4f190","187":"ee6a08e1","411":"cb37a111","566":"25f4ea41","755":"2c91c499","887":"6424b505"}[chunkId] + ".chunk.js";
};